const Error = () => {
  return (
    <>
      <h1>Oops! Error.....</h1>
      <p>Sorry, an unexpected error has occurred.</p>
    </>
  );
};

export default Error;
